import { Track } from 'livekit-client';
import { useTranslation } from 'react-i18next';
import {
  TrackReference,
  useLocalParticipant,
  useTracks,
  VideoTrack,
} from '@livekit/components-react';
import { useUserQuery } from 'generated/graphql';
import { ConnectionIndicator } from '../ConnectionIndicator/ConnectionIndicator';
import styles from './ParticipantFeed.module.scss';

export function ParticipantFeed() {
  const { t } = useTranslation();
  const { localParticipant } = useLocalParticipant();
  const { data: userData } = useUserQuery();

  const trackRefs = useTracks(
    [
      { source: Track.Source.Camera, withPlaceholder: true },
      { source: Track.Source.Microphone, withPlaceholder: false },
    ],
    { onlySubscribed: false }
  );

  const localTrackRef = trackRefs.find(
    trackRef => trackRef.participant.isLocal
  );

  if (!localTrackRef) {
    return <p>{t('aiInterview.waitingForCamera')}</p>;
  }

  const isCameraEnabled = localTrackRef.publication?.track?.isMuted === false;

  const participantFullName = `${userData?.User.firstName} ${userData?.User.lastName}`;

  return (
    <div className={styles.participantFeed}>
      {localParticipant && (
        <>
          <div className={styles.videoWrapper}>
            <VideoTrack
              trackRef={localTrackRef as TrackReference}
              className={styles.participantVideo}
            />
            {!isCameraEnabled && (
              <div className={styles.cameraOffOverlay}>
                <span className={styles.participantNameOverlay}>
                  {participantFullName}
                </span>
              </div>
            )}
            <div className={styles.connectionIndicatorWrapper}>
              <ConnectionIndicator />
            </div>
            {isCameraEnabled && (
              <div className={styles.participantNameCorner}>
                <span className={styles.participantNameText}>
                  {participantFullName}
                </span>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
